var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        { attrs: { align: "center" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c(
                "v-row",
                { attrs: { "no-gutters": "", align: "center" } },
                [
                  _c("MediaFilePicker", {
                    attrs: {
                      label: "Изображение",
                      multiple: false,
                      isShowCaption: true,
                      "file-type": _vm.$options.mediaTypesByKeys.IMAGE,
                      value: _vm.listItem.data.image,
                      caption: _vm.listItem.data.caption,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.mixUploadImageHandler($event, "image")
                      },
                      "change-caption": function ($event) {
                        return _vm.mixChangeListItemHandler($event, "caption")
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "preview-bottom",
                        fn: function () {
                          return [
                            _c("ErrorMessage", {
                              attrs: { message: _vm.errorMessages.image },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("span", [_vm._v("Заполнение изображения")]),
              _c("v-select", {
                attrs: {
                  outlined: "",
                  "item-value": "value",
                  "item-text": "title",
                  "return-object": "",
                  "hide-details": "",
                  dense: "",
                  disabled: _vm.isLoading,
                  loading: _vm.isLoading,
                  value: _vm.listItem.data.fit,
                  items: _vm.$options.imageFits,
                },
                on: {
                  change: function ($event) {
                    return _vm.mixChangeListItemHandler($event, "fit")
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c("span", [_vm._v("Ширина")]),
              _c("v-text-field", {
                attrs: {
                  outlined: "",
                  dense: "",
                  disabled: _vm.isLoading,
                  loading: _vm.isLoading,
                  value: _vm.fields.inputWidth,
                  "error-messages": _vm.errorMessages.width,
                },
                on: {
                  input: function ($event) {
                    return _vm.ChangingHandler($event, "Width", "input")
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c("span", [_vm._v("Ед. измерения")]),
              _c("v-select", {
                attrs: {
                  outlined: "",
                  "item-value": "value",
                  "item-text": "title",
                  "hide-details": "",
                  dense: "",
                  disabled: _vm.isLoading,
                  loading: _vm.isLoading,
                  value: _vm.fields.valueWidth,
                  items: _vm.$options.valueTypesCSSList,
                },
                on: {
                  change: function ($event) {
                    return _vm.ChangingHandler($event, "Width", "value")
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c("span", [_vm._v("Высота")]),
              _c("v-text-field", {
                attrs: {
                  outlined: "",
                  dense: "",
                  disabled: _vm.isLoading,
                  loading: _vm.isLoading,
                  value: _vm.fields.inputHeight,
                  "error-messages": _vm.errorMessages.height,
                },
                on: {
                  input: function ($event) {
                    return _vm.ChangingHandler($event, "Height", "input")
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c("span", [_vm._v("Ед. измерения")]),
              _c("v-select", {
                attrs: {
                  outlined: "",
                  "item-value": "value",
                  "item-text": "title",
                  "hide-details": "",
                  dense: "",
                  disabled: _vm.isLoading,
                  loading: _vm.isLoading,
                  value: _vm.fields.valueHeight,
                  items: _vm.$options.valueTypesCSSList,
                },
                on: {
                  change: function ($event) {
                    return _vm.ChangingHandler($event, "Height", "value")
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }